export { LitTypewriter } from "./lit-typewriter";
